import {Record} from "immutable";
import {
    onModifierArchive,
    onModifierArchiveFail,
    onModifierArchiveSuccess,
    onModifierCategoriesNew,
    onModifierCategoriesNewFail,
    onModifierCategoriesNewSuccess,
    onModifierCategoryNameEdit,
    onModifierCategoryNameEditFail,
    onModifierCategoryNameEditSuccess,
    onModifierEdit,
    onModifierEditFail,
    onModifierEditSuccess,
    onModifierLoad,
    onModifierLoadFail,
    onModifierLoadSuccess,
    onModifierNew,
    onModifierNewFail,
    onModifierNewLoad,
    onModifierNewSuccess,
    onModifierRemove,
    onModifierRemoveFail,
    onModifierRemoveSuccess,
    onModifiersChangeStatus, onModifiersEdit, onModifiersEditFail, onModifiersEditSuccess,
    onModifiersLoad, onModifiersLoadFail, onModifiersLoadSuccess, onModifiersModalEdit, 
    onModifiersModalNew, onModifiersNew, onModifiersNewFail, onModifiersNewSuccess, onModifierUnarchive, onModifierUnarchiveFail, onModifierUnarchiveSuccess,
} from "./actions";

const modifiers = new Record({
    modalNewModifier: false,
    modalEditModifier: false,
    loading: false,
    status: 'active',
    modifiers: [],
    modifier: {
        checked_restaurants:[],
        all_future_locations: false,
        is_all_restaurants: false,
        data: {}
    },
    restaurants: [],    
})();

export default (state = modifiers, action) => {
    switch (action.type) {
        case onModifiersLoad().type:
        case onModifierLoad().type:
            return state.set('loading', true);

        case onModifiersLoadSuccess().type:
            return state.set('loading', false)
                .set('modifiers', action.data.items);
                
        case onModifierLoadSuccess().type:
            return state
            .setIn(["modifier","data"], action.data.data)     
            // .setIn(["modifier","all_future_locations"], action.data.modifier.all_future_locations)
            // .setIn(["modifier","is_all_restaurants"], action.data.modifier.is_all_restaurants)
            // .setIn(["modifier","checked_restaurants"], action.data.modifier.checked_restaurants)
            .set("loading", false)   
                    
        case onModifiersLoadFail().type:
        case onModifierLoadFail().type:
            return state.set('loading', false);


        case onModifiersChangeStatus().type:
            return state.set('status', action.status);


        case onModifiersNew().type:
        case onModifierNew().type:
        case onModifierArchive().type:
        case onModifierUnarchive().type:
        case onModifierCategoriesNew().type:
            return state.set('loading', true);
        
        case onModifierNewLoad().type:
            return state.setIn(['modifier', 'data'], {
                id: null,
                name: "",
                is_required: false,
                can_items_repeat: false,
                max_checked: false,
                max_amount: null,
            });

        case onModifiersNewSuccess().type:
        case onModifierNewSuccess().type:
        case onModifierCategoriesNewSuccess().type:
        case onModifierArchiveSuccess().type:
        case onModifierUnarchiveSuccess().type:
        case onModifierArchiveFail().type:
        case onModifierUnarchiveFail().type:
        case onModifiersNewFail().type:
        case onModifierNewFail().type:
        case onModifierCategoriesNewFail().type:
            return state.set('loading', false);

        case onModifiersEdit().type:
        case onModifierEdit().type:
        case onModifierCategoryNameEdit().type:
        case onModifierRemove().type:
            return state.set('loading', true);

        case onModifiersEditSuccess().type:
        case onModifierEditSuccess().type:
        case onModifierCategoryNameEditSuccess().type:
        case onModifierRemoveSuccess().type:
        case onModifiersEditFail().type:
        case onModifierEditFail().type:
        case onModifierCategoryNameEditFail().type:
        case onModifierRemoveFail().type:
            return state.set('loading', false);

        case onModifiersModalNew().type:
            return state.set('modalNewModifier', action.show);

        case onModifiersModalEdit().type:
            return state.set('modalEditModifier', action.show);

        default:
            return state;
    }
}
